import { useState } from 'react';
import css from './FormSelectUsers.module.scss';
import T from '../../../../common/components/T';
import UsersModal from './components/UsersModal/UsersModal';
import { FieldError, svgSprite } from '../../../../hybrid/wrappers';

export default function FormSelectUsers(props) {
    const { setFormData, attribute, value = [], errors, fastSearch } = props;
    const [showModal, setShowModal] = useState(false);

    const selectHandler = (rowData) => {
        if (value && Array.isArray(value) && value?.find((user) => user.id === rowData?.id)) {
            setShowModal(false);
            return;
        }
        setFormData(attribute, [...(value || []), { ...rowData.user, id: rowData?.id }]);
    };

    const deleteHandler = (user) => {
        setFormData(
            attribute,
            value?.filter((elem) => elem?.id !== user?.id)
        );
    };

    return (
        <>
            <div className={css.wrapper}>
                <div onClick={() => setShowModal(true)} className={css.button}>
                    <T textName='select-user' defaultStr='Выбрать пользователя' />
                </div>
                {errors && errors.length
                    ? errors.map((err, idx) => <FieldError key={`${attribute}${idx}`}>{err}</FieldError>)
                    : null}
                {value?.length ? (
                    <div className={css.usersList}>
                        {value?.map((user) => (
                            <div key={user?.id} className={css.userItem}>
                                <p className={css.userItemName}>{user?.username || '-'}</p>
                                <div onClick={() => deleteHandler(user)} className={css.userItemDelete}>
                                    {svgSprite('cross', { className: css.userItemDeleteSvg })}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
            {showModal ? (
                <UsersModal fastSearch={fastSearch} onSelect={selectHandler} closeHandler={() => setShowModal(false)} />
            ) : null}
        </>
    );
}
